class WuInputField {
    constructor (elem) {
        this.inputField = elem.querySelector('.wu-input')
        this.searchInput = elem.getElementsByClassName('wuds-dropdown__search__box');
        this.currencyList = elem.querySelectorAll('.wuds-dropdown__search__list .wuds-dropdown__item')
        this.clearButton = elem.querySelector('.wuds-dropdown__search__cancel__icon')
        this.curDropdown = elem.querySelector('.wuds-dropdown--country');
        this.moreButton = elem.getElementsByClassName("icon-0024_dropdown-more");
        this.init();
    }

    init() {
        this.listeners();
        if(this.curDropdown && this.curDropdown.style) {
            this.curDropdown.style.display='none';
        }
    }

    listeners() {
        if (document.addEventListener) {
            
            document.getElementsByTagName('body')[0].addEventListener('click', e => {
                this.currencyDropdownToggle(e)
            })
            this.searchInput && this.searchInput[0] && this.searchInput[0].addEventListener('keyup', e => {
                this.searchFilter()
            })
            this.clearButton?.addEventListener('click', e => {
                this.onClickClear()
            })

        } else if (document.attachEvent) {

            document.getElementsByTagName('body')[0].addEventListener('click', e => {
                this.currencyDropdownToggle()
            })
            this.searchInput && this.searchInput[0] && this.searchInput[0].addEventListener('keyup', e => {
                this.searchFilter()
            })
            this.clearButton?.addEventListener('click', e => {
                this.onClickClear()
            })
        }
    }

    onClickClear(){
        this.searchInput && this.searchInput[0].focus();
        this.searchInput ? this.searchInput[0].value = "" : undefined;
        for (let i = 0; i <= this.currencyList.length - 1; i++) {
            this.currencyList[i].style.display = 'block';
        }
    }
    
    searchFilter() {
        this.searchInput && this.searchInput[0].value.length > 0 ? this.clearButton.style.display = 'flex' : this.clearButton.style.display = 'none' ; 
        if (
            this.currencyList && this.currencyList.length > 0
        ) {
            for (
                let i=0;
                i<this.currencyList.length;
                i++
            ) {
                let currency = this.currencyList[i]
                let title = currency && currency.querySelector(".b-flag-select__text").innerText;
                this.searchInput && this.searchInput[0] &&
                title.toUpperCase().indexOf(this.searchInput[0].value.toUpperCase()) > -1 ? currency.style.display = 'block' : currency.style.display = 'none';
            }
        }
    }

    clearSearch() {
        this.searchInput && this.searchInput[0].focus();
        this.searchInput ? this.searchInput[0].value = "" : undefined;
        this.searchFilter()
    }

    currencyDropdownToggle(e){
        let ip = document.querySelector('.amount');                
        ip.setAttribute('value',ip.value);
        (ip.getAttribute('data-value') != ip.value) ? sessionStorage.setItem('currency-converter-amount', ip.value) :  sessionStorage.removeItem('currency-converter-amount');

        if (
            (e.target && e.target.classList.contains('receiverCurrencyDrop'))
        ) {
            this.moreButton && this.moreButton[0].classList.toggle("down");
            this.curDropdown.style.display = this.curDropdown.style.display === 'none' ? 'block' : 'none';
            this.clearSearch();
        } else if (
            (e.target && e.target.classList.contains('b-language-dropdown'))
        ) {
            this.moreButton && this.moreButton[0].classList.toggle("down");
            this.curDropdown.style.display = this.curDropdown.style.display === 'none' ? 'block' : 'none';
            
        } else if (
            e.target.id && 
            (e.target.id==='searchInput' || e.target.id==='clear') 
        ) {
            this.curDropdown.style.display = 'block';
        } else {
            this.curDropdown.style.display = 'none';
            this.clearSearch();
            if (this.moreButton && this.moreButton.length > 0 && this.moreButton[0].classList.contains("down"))
                this.moreButton && this.moreButton[0].classList.toggle("down");
        }
    }
}

function loadCurrencyDropdown() {
    const ccSelectDropdowns = document.querySelectorAll('.currency-select-dropdown');

    if (ccSelectDropdowns.length > 0) {
        for (
            let i=0; 
            i<ccSelectDropdowns.length; 
            i++
        ) {
            new WuInputField(ccSelectDropdowns[i])
        }
    }
}